import store from '../store'
import BaseService from './BaseService'
class LaunchService extends BaseService {
  constructor(option) {
    const { host, commonData, commonOption, interceptors } = option
    super({
      host,
      commonData,
      commonOption,
      interceptors,
    })
    this.API = {
      init: '/api/v1.0/activity/index',
      getCoupon: ['/api/v1.0/reward/receive', 'post2'],
      getRewardList: '/api/v1.0/reward/list',
      getSunflowerCode: '/api/v1.0/activity/code/generate',
      getPosterImage: ['/api/v1.0/activity/poster/generate', 'post2'],
      getSignInfo: '/api/v1.0/signIn/list',
      getPosterCheck: '/api/v1.0/signIn/poster/check',
    }

    for (const key in this.API) {
      if (this[key]) continue
      this[key] = async (params, options) => {
        if (typeof this.API[key] === 'string') {
          return this.get2(this.API[key], { params, ...options })
        } else if (Array.isArray(this.API[key])) {
          const [url, method] = this.API[key]
          return this[method](url, params, options)
        }
      }
    }
  }

  get2(url, option) {
    return this.get(url, option).catch(e => {
      return Promise.resolve({
        errno: -999,
        errmsg: '请求错误',
        data: null,
        errdata: e,
      })
    })
  }

  post2(url, params, option = {}) {
    return this.post(url, params, option).catch(e => {
      return Promise.resolve({
        errno: -999,
        errmsg: '请求错误',
        data: null,
        errdata: e,
      })
    })
  }

  getBanner(params) {
    return this.post2(
      'https://res.xiaojukeji.com/resapi/activity/mget',
      params,
      {
        emulateJSON: true,
      }
    )
  }
}

export function getCommonData(option = {}) {
  const { userInfo, cityInfo, productType, query } = store.getters
  const params = {
    dsi: query.dsi,
    source_id: query.source_id,
    product_type: productType,
    dchn: query.dchn,
  }
  userInfo.token && (params.token = userInfo.token)
  if (option.hasLocate !== false) {
    cityInfo.cityId && (params.city_id = Number(cityInfo.cityId))
    cityInfo.lng && (params.lng = String(cityInfo.lng))
    cityInfo.lat && (params.lat = String(cityInfo.lat))
  }
  return params
}

export default new LaunchService({
  host: 'https://union.didi.cn',
  commonData: getCommonData,
})
